import { createPalette } from 'styles/theme/colors';
import { TARGET_IDENTIFIERS } from 'styles/theme/brand/constants';
import {
  DEFAULT_BUTTON_COLORS,
  DEFAULT_CARD_AND_BACKGROUND_VALUES,
  DEFAULT_ERROR_VALUES,
  DEFAULT_HEADER_AND_NAVIGATION_VALUES,
  DEFAULT_MENU_ITEM_NAME_VALUES,
  DEFAULT_MENU_SECTION_TITLE_VALUES,
  DEFAULT_BACKGROUND_VALUES
} from 'styles/helpers/emptyThemeValues';

export const getButtonColorsPalette = brandStyles => {
  const fontColor =
    brandStyles?.[TARGET_IDENTIFIERS.PRIMARY_BUTTON]?.color ||
    DEFAULT_BUTTON_COLORS.color;

  const bgColor =
    brandStyles?.[TARGET_IDENTIFIERS.PRIMARY_BUTTON]?.backgroundColor ||
    DEFAULT_BUTTON_COLORS.backgroundColor;
  const hoverFontColor =
    brandStyles?.[TARGET_IDENTIFIERS.PRIMARY_BUTTON_HOVER]?.color ||
    DEFAULT_BUTTON_COLORS.hoverColor;
  const hoverBgColor =
    brandStyles?.[TARGET_IDENTIFIERS.PRIMARY_BUTTON_HOVER]?.backgroundColor ||
    DEFAULT_BUTTON_COLORS.hoverBackgroundColor;

  return {
    button: {
      font: {
        main: fontColor,
        hover: hoverFontColor
      },
      background: {
        main: bgColor,
        hover: hoverBgColor
      }
    }
  };
};

export const getMenuItemNamesPalette = brandStyles => {
  const color =
    brandStyles?.[TARGET_IDENTIFIERS.MENU_ITEM_NAME]?.color ||
    DEFAULT_MENU_ITEM_NAME_VALUES.color;

  return {
    menuItemNames: {
      main: color
    }
  };
};

export const getMenuSectionTitlesPalette = brandStyles => {
  const color =
    brandStyles?.[TARGET_IDENTIFIERS.MENU_SECTION_TITLE]?.color ||
    DEFAULT_MENU_SECTION_TITLE_VALUES.color;

  return {
    menuSectionTitles: {
      main: color
    }
  };
};

export const getCardAndBackgroundPalette = brandStyles => {
  const cardBackgroundColor =
    brandStyles?.[TARGET_IDENTIFIERS.CARD]?.backgroundColor ||
    DEFAULT_CARD_AND_BACKGROUND_VALUES.cardBackgroundColor;
  const cardBorderColor =
    brandStyles?.[TARGET_IDENTIFIERS.CARD]?.borderColor ||
    DEFAULT_CARD_AND_BACKGROUND_VALUES.cardOutlineColor;
  const cardBoxShadow =
    brandStyles?.[TARGET_IDENTIFIERS.CARD]?.boxShadow ||
    DEFAULT_CARD_AND_BACKGROUND_VALUES.dropShadow;
  const pageBackgroundColor =
    brandStyles?.[TARGET_IDENTIFIERS.PAGE]?.backgroundColor ||
    DEFAULT_CARD_AND_BACKGROUND_VALUES.pageBackgroundColor;

  return {
    card: {
      background: {
        main: cardBackgroundColor
      },
      outline: {
        main: cardBorderColor
      },
      dropShadow: cardBoxShadow
    },
    page: {
      background: {
        main: pageBackgroundColor
      }
    }
  };
};

export const getHeaderAndNavigationPalette = brandStyles => {
  const headerAccentColor =
    brandStyles?.[TARGET_IDENTIFIERS.HEADER_NAVIGATION_ACTIVE]?.color ||
    DEFAULT_HEADER_AND_NAVIGATION_VALUES.accentColor;
  const headerBackgroundColor =
    brandStyles?.[TARGET_IDENTIFIERS.HEADER_NAVIGATION]?.backgroundColor ||
    DEFAULT_HEADER_AND_NAVIGATION_VALUES.headerBackgroundColor;
  const headerLinkColor =
    brandStyles?.[TARGET_IDENTIFIERS.HEADER_NAVIGATION]?.color ||
    DEFAULT_HEADER_AND_NAVIGATION_VALUES.headerLinkColor;
  const headerLinkHoverColor =
    brandStyles?.[TARGET_IDENTIFIERS.HEADER_NAVIGATION_HOVER]?.color ||
    DEFAULT_HEADER_AND_NAVIGATION_VALUES.headerLinkHoverColor;
  const navigationAccentColor =
    brandStyles?.[TARGET_IDENTIFIERS.MENU_NAVIGATION_ACTIVE]?.color ||
    DEFAULT_HEADER_AND_NAVIGATION_VALUES.accentColor;
  const navigationLinkColor =
    brandStyles?.[TARGET_IDENTIFIERS.MENU_NAVIGATION]?.color ||
    DEFAULT_HEADER_AND_NAVIGATION_VALUES.sectionNavigationLinkColor;
  const navigationLinkHoverColor =
    brandStyles?.[TARGET_IDENTIFIERS.MENU_NAVIGATION_HOVER]?.color ||
    DEFAULT_HEADER_AND_NAVIGATION_VALUES.sectionNavigationLinkHoverColor;

  return {
    header: {
      accent: {
        main: headerAccentColor
      },
      background: {
        main: headerBackgroundColor
      },
      link: {
        main: headerLinkColor,
        hover: headerLinkHoverColor
      }
    },
    sectionNav: {
      accent: {
        main: navigationAccentColor
      },
      link: {
        main: navigationLinkColor,
        hover: navigationLinkHoverColor
      }
    }
  };
};

export const getErrorPalette = brandStyles => {
  const color =
    brandStyles?.[TARGET_IDENTIFIERS.PAGE_ERROR]?.color ||
    DEFAULT_ERROR_VALUES.color;

  return {
    error: {
      main: color
    }
  };
};

export const getPalette = transformedBrandStyles => {
  const basePalette = createPalette();
  const { button } = getButtonColorsPalette(transformedBrandStyles);
  const { menuItemNames } = getMenuItemNamesPalette(transformedBrandStyles);
  const { menuSectionTitles } = getMenuSectionTitlesPalette(
    transformedBrandStyles
  );
  const { card, page } = getCardAndBackgroundPalette(transformedBrandStyles);
  const { header, sectionNav } = getHeaderAndNavigationPalette(
    transformedBrandStyles
  );
  const { error } = getErrorPalette();

  return {
    ...basePalette,
    button,
    menuItemNames,
    menuSectionTitles,
    card,
    page,
    header,
    sectionNav,
    error,
    background: {
      default: page.background.main,
      secondary: DEFAULT_BACKGROUND_VALUES.secondary
    }
  };
};
